var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-shipping-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var brief = ref.brief;
var contact = ref.contact;
var step = ref.step;
var currentStep = ref.currentStep;
var isPreview = ref.isPreview;
var completeBrief = ref.completeBrief;
var patchStep = ref.patchStep;
var goNextStep = ref.goNextStep;
var goPreviousStep = ref.goPreviousStep;
var isLoading = ref.isLoading;
var isCompletingBrief = ref.isCompletingBrief;
var loadingCountries = ref.loadingCountries;
var loadingProvinces = ref.loadingProvinces;
var countries = ref.countries;
var provinces = ref.provinces;
var countryUpdated = ref.countryUpdated;
var errors = ref.errors;
var errorMessage = ref.errorMessage;
return [_c('activation-brief-shipping-view',{attrs:{"brief":brief,"contact":contact,"is-preview":isPreview,"step":step,"countries":countries,"provinces":provinces,"current-step":currentStep,"is-loading":isLoading,"is-additional-order":_vm.isAdditionalOrder,"loading-countries":loadingCountries,"loading-provinces":loadingProvinces,"errors":errors,"error-message":errorMessage},on:{"country-updated":countryUpdated,"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchStep,"chountry-updated":countryUpdated}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }